import React from 'react';
import HostPortalStore from './HostPortalStore';
import HostPortalActions from './HostPortalActions';
import PhysicalParty from './PhysicalParty';
import VirtualParty from './VirtualParty';
import {SelectField} from 'form-fields';


export default class BookAPartyContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = HostPortalStore.getState();
		this.onChange = this.onChange.bind(this);
	}

	componentDidMount() {
		HostPortalStore.listen(this.onChange);
		HostPortalActions.getEventTypes();
		HostPortalActions.clearFormValues();
		HostPortalActions.getTimeZones();
	}

	componentWillUnmount() {
		HostPortalStore.unlisten(this.onChange);
	}

	onChange(state) {
		this.setState(state);
	}

	updateVirtual(isVirtual) {
		HostPortalActions.setVirtual(isVirtual);
	}

	render(){
		let ComponentToDisplay = this.state.isVirtual ? <VirtualParty {...this.state}  {...this.props}/> : <PhysicalParty {...this.state}  {...this.props}/>;
		if (!this.state.hasVirtual) {
			ComponentToDisplay = <PhysicalParty {...this.state}  {...this.props}/>;
		}

		let virtualRadio = this.state.hasVirtual ? 
								<label className="input-auto" style={{fontWeight: 'normal', marginRight: 15}}>
									<input type="radio" name="locationType" value="online" checked={this.state.isVirtual} onChange={this.updateVirtual.bind(this, true)} /> {this.props.resources["PWS.MyAccount.VirtualPartyText"]}
								</label> : '';


 		return (
			<div id="bookPartyWizard" className="wizard clearfix">
				<div id="bookParty" className="wizard-content clearfix">
					<div className="wizard-pane clearfix">
						<div className="input-50">
							<div className="formSectionSubTitle">{this.props.resources["PWS.MyAccount.PartyTypeLabel"]}</div>
							<div>
								{virtualRadio}
								<label className="input-auto" style={{fontWeight: 'normal'}}>
									<input type="radio" name="locationType" value="physicaladdress" checked={!this.state.isVirtual} onChange={this.updateVirtual.bind(this, false)} /> {this.props.resources["PWS.MyAccount.PhysicalPartyText"]}
								</label>
							</div>
						</div>
						<div id="partyThemeSelector" className="input-33">
							<div className="formSectionSubTitle">{this.props.resources["PWS.MyAccount.PartyThemeLabel"]}</div>
							<div>
								<SelectField
									ref="partyTheme"
									optionData={this.state.DisplayThemeList}
									keys={{valueKey: 'code', nameKey: 'description'}}
									name="selectedTheme"
									value={this.state.selectedTheme}
									handleChange={HostPortalActions.changeTheme.bind(this)}
									label={this.props.resources["PWS.MyAccount.PartyThemeLabel"]}
									showEmptyOption={false}
								/>
							</div>
						</div>
						<div className="spacer12"></div>
						<div className="simpleHR"></div>
						<div className="spacer12"></div>

						{ComponentToDisplay}
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/BookAPartyContainer.js